import { Component, ViewChild, ElementRef, OnInit, Input } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { ApiConstants } from '../../shared';
import { AddToAccountModalService } from './add-to-account-modal.service';
import { GeneralConstants } from '../../shared/general.constants';
import { DPSubscriptionService } from '../../portalv1';
import { DPTitleBatchRequest } from '../../portalv1/model/dp-title-batch-request';
import { CatalogService } from '../catalog-api/catalog.service';

@Component({
    selector: 'add-to-account-modal',
    templateUrl: 'add-to-account-modal.component.html',
    styleUrls: ['add-to-account-modal.component.scss']
})
export class AddToAccountModal implements OnInit {
    @ViewChild('modal', { read: ElementRef }) modal: ElementRef;

    private accounts;
    private accountId;
    private loading = false;
    private accountIdLocked = false;

    private _titlesToAdd;
    @Input()
    set titlesToAdd(titlesToAdd: any[]) {
        if (titlesToAdd && titlesToAdd.length > 0) {
            if (!this.accountIdLocked) {
                this.accountId = null;
            }
            this._titlesToAdd = titlesToAdd;
            this.openModal();
        }
    }

    @Input()
    set lockedAccountId(accountId: string) {
        this.accountIdLocked = true;
        this.accountId = accountId;
    }

    constructor(private toasterService: ToasterService,
        private apiConstants: ApiConstants,
        private generalConstants: GeneralConstants,
        private dpSubscriptionsService: DPSubscriptionService,
        private catalogService: CatalogService,
        private addToAccountModalService: AddToAccountModalService) { }

    ngOnInit() {
        this.addToAccountModalService.getAccounts()
            .then((accounts) => {
                this.accounts = accounts;
            });
    }

    openModal() {
        this.modal.nativeElement.style.display = 'block';
    }

    closeModal() {
        this.modal.nativeElement.style.display = 'none';
    }

    handleSubmit() {
        this.loading = true;
        // Validation
        if (!this.accountId) {
            this.toasterService.pop('error', 'Please select an account');
            this.loading = false;
            return;
        }
        if (this.accountId == this.generalConstants.getAllAccessAccountId()
            && this._titlesToAdd.some((title) => {
                // Return true for invalid titles
                if ((title.contentType === 'Talent'
                ) || title.contentType === 'Movie'
            ) {
                    return false;
                }else if ((
                    // Genre tags - DISABLED until genre tags can be edited
                    title.genreTags.length === 0 ||
                    // Language
                    !title.originalLanguage ||
                    // Release year
                    !title.releaseYear ||
                    // Country
                    !title.originalCountry ||
                    // Network
                    !title.originalNetwork ||
                    // Total seasons
                    !title.totalSeasons ||
                    // Total episodes
                    !title.totalEpisodes ||
                    // Short description
                    !title.shortDescription)){

                }
                return false;
            })) {
            // Check that each title has the required verified genes
            this.toasterService.pop('error', 'At least one of the selected titles do not have the required verified genes');
            this.loading = false;
            return;
        }
        // Handle submit
        const parrotIds = this._titlesToAdd.map(item => item.parrotId);
        const contentType = this._titlesToAdd.map(item => item.contentType);
        const titlesList: DPTitleBatchRequest = {
            titles: parrotIds
        };
        if (this.accountId == this.generalConstants.getAllAccessAccountId()) {
            // Update catalog state as well
            Promise.all([
                //dont need this any more since lambda take care of subscription sync
                //this.dpSubscriptionsService.addTitleBatch(titlesList, this.accountId),
                this.catalogService.updateGenome(
                    parrotIds, Array(parrotIds.length).fill('catalog_state'), Array(parrotIds.length).fill('client_ready'), contentType
                )
            ])
                .then(resArray => {
                    // const addTitleBatchRes: any = resArray[0];
                    const updateGenomeRes: any = resArray[0];
                    if ( updateGenomeRes && updateGenomeRes.message === this.generalConstants.getGenomeDataSuccessMessage()) {
                        this.toasterService.pop('success',
                            'Successfully added the selected titles customer ready');
                    } else {
                        console.error('Error adding the selected titles to customer ready: '
                            + resArray);
                        this.toasterService.pop('error',
                            'Failed to add the selected titles to customer ready');
                    }
                    this.loading = false;
                    this._titlesToAdd = [];
                    this.closeModal();
                })
                .catch((err) => {
                    console.error('Failed to add titles to customer ready: ', err);
                    this.toasterService.pop('error', 'Failed to add titles to customer ready!');
                    this.loading = false;
                });
        } else {
            this.dpSubscriptionsService.addTitleBatch(titlesList, this.accountId)
                .then(res => {
                    this.loading = false;
                    this._titlesToAdd = [];
                    if (res) {
                        this.toasterService.pop('success',
                            'Successfully added the selected titles customer ready');
                    } else {
                        console.error('Error adding the selected titles to customer ready: '
                            + res);
                        this.toasterService.pop('error',
                            'Failed to add the selected titles to customer ready');
                    }
                    this.loading = false;
                    this._titlesToAdd = [];
                    this.closeModal();
                })
                .catch((err) => {
                    console.error('Failed to add titles to customer ready: ', err);
                    this.toasterService.pop('error', 'Failed to add titles to customer ready!');
                    this.loading = false;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/add-to-acount-modal/add-to-account-modal.component.ts